import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';

gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', () => {

	// Initialize Clients Swiper
	const clientsSwiper = document.querySelector('.clients-swiper');

	if (clientsSwiper) {
		new Swiper('.clients-swiper', {
			modules: [Navigation, Pagination, Autoplay],
			slidesPerView: 3,
			spaceBetween: 30,
			loop: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 30,
				},
				1024: {
					slidesPerView: 6,
					spaceBetween: 40,
				},
			},
		});
	}

	// Initialize Stories Swiper
	const storiesSwiper = document.querySelector('.stories-swiper');

	if (storiesSwiper) {
		new Swiper('.stories-swiper', {
			modules: [Navigation, Pagination, Autoplay],
			slidesPerView: 1,
			spaceBetween: 30,
			loop: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
		});
	}


	// Animate Impact Rings on Scroll with Stagger
	const impactRings = document.querySelectorAll('.impact-ring');

	// Calculate circle circumference (used for all rings)
	const radius = 45;
	const circumference = 2 * Math.PI * radius;

	// Set initial state for all rings
	impactRings.forEach((ring) => {
		const fillCircle = ring.querySelector('.impact-ring-fill');
		if (fillCircle) {
			fillCircle.style.strokeDasharray = circumference;
			fillCircle.style.strokeDashoffset = circumference;
		}
	});

	// Group rings by their parent container to apply stagger within groups
	const impactContainers = new Set();
	impactRings.forEach((ring) => {
		const container = ring.closest('.story-card_impact, .row, section');
		if (container) {
			impactContainers.add(container);
		}
	});

	// Animate each group with stagger
	impactContainers.forEach((container) => {
		const ringsInContainer = container.querySelectorAll('.impact-ring');

		if (ringsInContainer.length > 0) {
			ScrollTrigger.create({
				trigger: container,
				start: 'top 80%',
				once: true,
				onEnter: () => {
					ringsInContainer.forEach((ring, index) => {
						const targetPercent = parseFloat(ring.getAttribute('data-percent')) || 0;
						const fillCircle = ring.querySelector('.impact-ring-fill');
						const numberElement = ring.querySelector('.impact-ring-number');

						if (!fillCircle || !numberElement) return;

						// Calculate stagger delay
						const staggerDelay = index * 0.2;

						// Animate the ring fill
						const offset = circumference - (targetPercent / 100) * circumference;
						gsap.to(fillCircle, {
							strokeDashoffset: offset,
							duration: 1.5,
							ease: 'power2.out',
							delay: staggerDelay
						});

						// Animate the number counter
						gsap.to(numberElement, {
							innerHTML: targetPercent,
							duration: 1.5,
							ease: 'power2.out',
							snap: { innerHTML: 1 },
							delay: staggerDelay,
							onUpdate: function() {
								numberElement.innerHTML = Math.round(numberElement.innerHTML);
							}
						});
					});
				}
			});
		}
	});

});

export default function initSwiper() {
	// Additional initialization if needed
}
